<div style="width: 700px; max-width: 100%">
  <h2 class="mb-4">Invite Client Users</h2>

  <p>
    Now that you have setup the client portal, you can invite clients to become users and collaborate with your firm in
    Client Hub.
  </p>
  <p>
    Choose the <strong><i class="tio-group_equal"></i> Clients and Workspaces</strong> menu on left
    navigation, choose the client and go to their <strong>
      <i class="tio-info"></i> Client Details</strong> tab.
  </p>
  <p>
    There:
  </p>
  <ul>
    <li>
      If you have already imported someone as a Contact, you’ll see them in the Contacts list and you can select the
      <strong><i class="tio-user_add"></i> Invite as User</strong> button to send an email invite to them.
    </li>
    <li>
      If you have not used the Import clients feature, you can just use the <strong><i class="tio-user_add"></i> Add
        Client User</strong> button to invite a client to Client Hub.
    </li>
  </ul>
</div>